import {
  Component, effect,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal
} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {User} from "../../../user/user";
import {RouteData} from "../../../shared/services/route-data/route-data";
import {combineLatest, Observable, Subscription} from "rxjs";
import {RouteDataService} from "../../../shared/services/route-data/route-data.service";
import {UserService} from '../../../user/user.service';
import * as fromStore from "../../../store";
import {Store} from '@ngrx/store';
import {distinctUntilChanged, filter, first, switchMap} from 'rxjs/operators';
import {DbResponse} from '../../../shared/interceptors/db-response';
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../user/user-subscription";
import {Utils} from "../../../shared/utils/utils";
import {CookieService} from "ngx-cookie";
import {CompanyInfo} from "../../../store/actions/company-info.action";
import {ActivityStatus, IActivity} from "../../../activities/activity";
import {Website} from "../../../websites/website/website";
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {clientRoles} from "../../../user/user-roles-actions";
import {
  NotificationDialogService
} from "../../../shared/components/dialogs/notification-dialog/notification-dialog.service";
import {Workspace} from "../../../user-managment/workspace";
import {GlobalEvent} from "../../../shared/services/global-event-dispatcher/global-event";
import {UserManagementService} from "../../../user-managment/user-management.service";
import {
  GlobalEventDispatcherService
} from "../../../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {TypeUtils} from "../../../shared/utils/type-utils";
import {PageLoadingBarService} from "../../../shared/services/page-loading-bar/page-loading-bar.service";
import {DbModalService} from "../../../modules/modal/modal";
import {Config} from "../../../config/config";
import {Payment} from "../../../user/payment";
import {
  OneWeekFreeDemoUpgradeComponent
} from "../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {UserSubscriptionStatus} from "../../../user/user-subscription-status";
import {SidebarNavigationService} from "../../services/navigation/sidebar-navigation.service";
import {MainHeaderService} from "../../../main-header/main-header.service";
import {
  PricingPageViewComponent
} from "../../../shared/components/dialogs/one-month-free/components/pricing-page-view/pricing-page-view.component";

@Component({
    selector: 'db-primary-sidebar',
    templateUrl: './primary-sidebar.component.html',
    styleUrls: ['./primary-sidebar.component.scss'],
    standalone: false
})
export class PrimarySidebarComponent implements OnInit, OnDestroy {

  @Input() hasHostingOfferBanner: boolean;
  @Input() fromDomain: boolean;
  @Input() hasGlobalBanner?: boolean = false;
  @Output() switchLoading = new EventEmitter<boolean>();

  UserSubscriptionCategory = UserSubscriptionCategory;
  routeData: RouteData;
  user: User;
  website: Website;
  userSubscription: UserSubscription;
  userSubscriptionType = UserSubscriptionType;
  currentWorkspace: Workspace;
  ownerWorkspace: Workspace;
  websites: Website[];
  canViewContent: boolean;
  showNpsPopup: boolean;
  show2faPopup: boolean;
  disableCopyWebsite: boolean = false;
  hideMenuItems: boolean = false;
  hostedWebsites: Website[];
  hostedWebsitesWithMulti: Website[];
  connectedWebsites: Website[];
  isMobile: boolean = false;
  canCreateWebsite: boolean;
  canViewWebsitesListing: boolean;
  canOpenAddWebsiteDialog: any;
  canGoToWebsiteInnerPage: boolean;
  bluredContent: boolean;
  workspaces: Workspace[] = [];
  UserSubscriptionType = UserSubscriptionType;
  referralPageSeen: any;
  showPercentOffer: boolean;
  fromGallery: boolean;
  demoUser: boolean;
  payments: Payment[];
  userSubscriptionStatus = UserSubscriptionStatus;
  isWorkspaceStatusInvited: boolean;
  checkPageAndWorkspace: boolean;
  companyInfo: CompanyInfo;
  conditionalPages: boolean;
  isTrialExpired: boolean;
  expiredSubscr: boolean;
  isSiteDev: boolean;
  showActivitiesIcon: boolean;
  trialOrOptimizerTrial: boolean;
  workspaceRoles = clientRoles;
  daysUntilNext: number;
  percentageLeft: number;
  openedKnowledgeBase: boolean;
  openedUsageSummary: boolean;
  activeFeature: 'knowledge-base' | 'whats-new' | 'usage-summary' | null = null;
  knowLedgeBaseToggled$: Observable<boolean>;
  usageSummaryToggled$: Observable<boolean>;
  userLocalStorage: any;
  page: string = 'website';
  hasUpgrade: boolean;
  isGlobalPage: boolean = false;
  hasApiService: boolean = false;
  iconAnimation: boolean = false;
  freeDays = 0;
  showContactPopup: boolean = false;
  showFreeDaysCount: boolean = true;
  vibeLimitationData: any;
  usedAiCredits$ = this._store.select(fromStore.selectUsedAiCredits);
  showFreeTrialTooltip = signal(null);

  public get isSidebarCollapsed(): boolean {
    return this.isSidebarCollapsedSignal();
  }

  private _subscriptions: Subscription[];
  private nps: any;
  protected readonly Config = Config;
  private readonly isSidebarCollapsedSignal = signal<boolean>(false);

  constructor(
    public sidebarNavigationService: SidebarNavigationService,
    public _router: Router,
    private _store: Store<fromStore.DbStoreState>,
    private _routeDataService: RouteDataService,
    private _dialogService: DialogService,
    private _userService: UserService,
    private _cookieService: CookieService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _userManagementService: UserManagementService,
    private _globalEventDispatcher: GlobalEventDispatcherService,
    private _pageLoadingBarService: PageLoadingBarService,
    private _modalService: DbModalService,
    private _mainHeaderService: MainHeaderService,
  ) {
  }

  ngOnInit() {
    this.routeData = this._routeDataService.getCurrentRouteData();
    this.isMobile = window.innerWidth <= 1024;
    this.isGlobalPage = !this.routeData?.hasSecondarySidebar && !this._router.url.includes('/websites/');
    this._store.dispatch(new fromStore.LoadUsedAiCredits());
    this._animateSidebar();
    this._getCompanyInfo();

    this.knowLedgeBaseToggled$ = this._store.select(fromStore.getKnowledgeBaseToggled);
    this.knowLedgeBaseToggled$.subscribe((isOpened: any) => {
      this.openedKnowledgeBase = isOpened;
      if (!isOpened) {
        // Reset the active feature when knowledge base is closed
        this.activeFeature = null;
      } else if (isOpened && !this.activeFeature) {
        // If knowledge base is opened but no feature is active, default to knowledge-base
        this.activeFeature = 'knowledge-base';
      }
    });
    this.usageSummaryToggled$ = this._store.select(fromStore.getUserSummariesToggled);
    this.usageSummaryToggled$.subscribe((isOpened: any) => {
      this.openedUsageSummary = isOpened;
      if (!isOpened) {
        // Reset the active feature when usage summary is closed
        if (this.activeFeature === 'usage-summary') {
          this.activeFeature = null;
        }
      }
    });
    this.addSubscriptions();
    this.isWorkspaceStatusInvited = this.currentWorkspace && ['invited'].includes(this.currentWorkspace?.status);

    // Initialize page from current route
    this.page = this.routeData?.data?.pageId || 'website';

    // Subscribe to route changes
    this._router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.routeData = this._routeDataService.getCurrentRouteData();
        this.page = this.routeData?.data?.pageId || 'website';
        this.isGlobalPage = !this.routeData?.hasSecondarySidebar && !this._router.url.includes('/websites/');
        this._animateSidebar();
      });
  }

  private _animateSidebar() {
    this.sidebarNavigationService.isSidebarVisible.subscribe(isVisible => {
      if (this.isMobile) {
        // For mobile, when isVisible is true, we want to show the sidebar
        this.isSidebarCollapsedSignal.set(!isVisible);
      }
    });

    if (this.isGlobalPage && !this.isMobile) {
      this.isSidebarCollapsedSignal.set(false);
    } else {
      this.isSidebarCollapsedSignal.set(this.isMobile || this.routeData?.hasSecondarySidebar);
    }
  }


  private _getCompanyInfo(): void {
    this._store.select(fromStore.getCompanyInfoLoaded)
        .pipe(
            filter((loaded: boolean) => loaded),
            switchMap(() => this._store.select(fromStore.getCompanyInfo)),
            first()
        )
        .subscribe((companyInfo: any) => {
          this.companyInfo = companyInfo;
        });
  }

  public innerVariables(): void {
    this.canViewContent = this.user && this.user.permissions.canViewContent;
    this.canCreateWebsite = this.currentWorkspace && this.currentWorkspace.roleId !== clientRoles.SITE_DEV;
    const aiRecreationCount: any = this.user ? Number(localStorage.getItem('aiRecreationCount' + this.user.id)) : 0;
    // Calculate days until next billing and progress percentage
    if (this.userSubscription) {
      this.showFreeDaysCount = this.userSubscription?.plan?.trialPeriodNumber !== 0 ||
        (this.userSubscription?.hostingTrialExpireDate && new Date(this.userSubscription.hostingTrialExpireDate) >= new Date());
      this._calculateBillingProgress(
        this.userSubscription.nextBillingDate?.toString() ||
        this.userSubscription.expireDate?.toString() || this.userSubscription?.hostingTrialExpireDate?.toString(),
      );
    }
  }

  private _calculateBillingProgress(nextBillingDate: string) {
    if (!nextBillingDate) return;

    const currentDate = new Date();
    const nextDate = new Date(nextBillingDate);

    this.daysUntilNext = Math.ceil((nextDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));

    this.freeDays = Math.ceil(
      (nextDate.getTime() - (
          TypeUtils.isDefined(this.userLocalStorage?.['extend_agreement'])
            ? currentDate.getTime()
            : this.userSubscription.agreementDate?.getTime())
      ) / (1000 * 60 * 60 * 24)
    );

    this.vibeLimitationData = {
      planLimit: this.userSubscription?.editTotal,
      alreadyUsed: this.userSubscription?.editUsed,
    };

    this.percentageLeft = Math.max(0, Math.min(100, (this.daysUntilNext / this.freeDays) * 100));
  }

  public showButtonsOrNot(): void {
    if (!this.userSubscription || !this.user) {
      return;
    }
    this.hideMenuItems = this.userSubscription &&
      ((this.userSubscription.trialOptimizerClient && (!this.websites || (this.websites && !this.websites.length))) ||
        ((this.user && this.userSubscription.oneProductClient && !this.user.websiteCreated && !this.user.websiteConnected) &&
          (!this.websites || (this.websites && !this.websites.length))));

    this.canOpenAddWebsiteDialog = this.user
      &&
      (
        (this.user.hosting_services && (!this.user.hasHostingTrial || !this.user.hostingTrialExpired)) ||
        this.websites.length)
      &&
      (!this.userSubscription?.trialClient ||
        (this.userSubscription?.trialClient &&
          ((this.connectedWebsites && this.connectedWebsites.length) || (this.hostedWebsites && this.hostedWebsites.length && this.hostedWebsites[0].migrated_from))))
      &&
      (!this.user?.agencyOrFreelancer || (this.user?.agencyOrFreelancer && (!this.userSubscription?.trialClient || this.hostedWebsites.length)));

    this.canGoToWebsiteInnerPage = this.canCreateWebsite && this.userSubscription.trialClient && (!this.connectedWebsites || (this.connectedWebsites && !this.connectedWebsites.length)) && this.hostedWebsites && this.hostedWebsites.length && !this.hostedWebsites[0].migrated_from;
    /*TODO check this variable condition*/
    this.canViewWebsitesListing = this.canViewContent && !this.hideMenuItems && (!this.user?.hasHostingTrial || !this.user?.hostingTrialExpired || this.user?.oneProductOrBundleClient) &&
      (!this.userSubscription?.trialClient ||
        (this.userSubscription?.trialClient && (this.user?.websiteConnected || this.user?.websiteCreated || this.currentWorkspace?.roleId !== clientRoles.OWNER)));
    /*this.limitExceeded = Utils.isTruthy(this.userSubscription && this.userSubscription.trialClient &&
      ((this.hostedWebsites && this.connectedWebsites && this.hostedWebsites.length >= 1 && this.connectedWebsites.length >= 1) ||
        (this.hostedWebsites && this.hostedWebsites.length === 1 && this.hostedWebsites[0].migrated_from)));*/

    if (this.user && this.websites && this.websites.length && !this.bluredContent) {
      this.show2faPopup = !localStorage.getItem('close2fadialog' + this.user.id) && !this.user.starterClient && !this.user.twoFaStatus && !this.showNpsPopup && this.payments && !!this.payments.length;
    }
  }


  showPricingDialog(category, action, label): void {
    const modal = this._modalService.open(PricingPageViewComponent, { overflowHidden: true, height: 960, width: 1076});
    modal.componentInstance.user = this.user;
    this.sendEvent(category, action, label);
  }

  navigateToUpgradePlan(): void {
    this._router.navigate(['/upgrade-plan']);
  }

  private _checkFreeTrialTooltipOpened(): void {
    if (this.userSubscription?.trialClient && !this.demoUser
      && +this.userSubscription?.product_id !== +Config.vibeCodingPluginId) {
      const lastOpened = localStorage.getItem('trial_tooltip_opened');
      const today = new Date().toDateString();
      if (lastOpened !== today) {
        localStorage.setItem('trial_tooltip_opened', today);
        this.showFreeTrialTooltip.set(true);
      }
    }
  }

  public stopEvent($event: any): void {
    !!this.isMobile && $event.stopPropagation();
  }

  ngOnDestroy() {
    this.removeSubscriptions();
  }

  @HostListener('window:resize') resize() {
    this.isMobile = window.innerWidth <= 1024;
    this.isGlobalPage = !this.routeData?.hasSecondarySidebar && !this._router.url.includes('/websites/');

    // Only collapse on resize if it's a small screen
    if (this.isMobile) {
      this.isSidebarCollapsedSignal.set(true);
    } else if (!this.isMobile && this.isGlobalPage) {
      // Force open for websites page on desktop
      this.isSidebarCollapsedSignal.set(false);
    }
  }

  public showCheckoutDialog(from: 'feature' | 'booster' | 'general' | null = 'feature', invitedClient: boolean = false): void {
    const analyticsData = {
      eventCategory: this.demoUser ? 'Dashboard Action' : 'Free trial paywalls',
      eventAction: "Upgrade button click",
      eventLabel: from === 'feature' ? "Dashboard: Invited Upgrade" : "Speed Booster: Pro Button",
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    if (invitedClient && (!localStorage.getItem('dbPreviousWorkspaceId') || !localStorage.getItem('dbPreviousWorkspaceRoleId')) && this.currentWorkspace?.roleId !== clientRoles.OWNER) {
      localStorage.setItem('dbPreviousWorkspaceId', localStorage.getItem('dbCurrentWorkspaceId'));
      localStorage.setItem('dbPreviousWorkspaceRoleId', localStorage.getItem('dbCurrentWorkspaceRoleId'));
    }
    if (!invitedClient) {
      if (this.userSubscription && this.userSubscription.trialBoosterClient) {
        this._router.navigate(['/upgrade-plan']);
      } else {
        if (this.demoUser) {
          const firstTime = TypeUtils.isNull(localStorage.getItem('dbShowFirstTime'));
          const options = {
            overflowHidden: false,
          };
          if (!firstTime) {
            options['width'] = 1240;
          } else {
            options['width'] = 460;
            options['height'] = 600;
          }
          const modal = this._modalService.open(OneWeekFreeDemoUpgradeComponent, options);
          modal.componentInstance.showFirstTime = firstTime;
          modal.componentInstance.isInvited = invitedClient;
        } else {
          const modal = this._modalService.open(PricingPageViewComponent, { overflowHidden: true, height: 960, width: 1076});
          modal.componentInstance.isInvited = invitedClient;
        }
      }
      return;
    }
    const switchToWorkspace = {
      ownerWorkspaceId: localStorage.getItem('dbOwnWorkspaceId'),
      currentWorkspaceId: localStorage.getItem('dbOwnWorkspaceId'),
      currentWorkspaceRoleId: 1
    };
    this._userManagementService.switchWorkspace(switchToWorkspace.currentWorkspaceId)
      .pipe(
        first(response => !!response, null),
      )
      .subscribe(response => {
        if (response.success) {
          this._globalEventDispatcher.dispatchEvent(GlobalEvent.workspaceSwitch);
        }
      });
  }

  public sendEvent(category, action, label) {
    const analyticsData = {
      eventCategory: category,
      eventAction: action,
      eventLabel: label
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }


  private addSubscriptions(): void {
    this._subscriptions = [];

    this._subscriptions.push(this._router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.routeData = this._routeDataService.getCurrentRouteData();
        this.showOrNot();
      })
    );

    this._subscriptions.push(
      this._store.select(fromStore.getOngoingActivities)
        .pipe(
          distinctUntilChanged((activity1: IActivity, activity2: any) => activity1 && activity2 && activity1.id === activity2.id),
          filter((loaded: any) => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getMigrationOngoingActivity),
            this._store.select(fromStore.getCreateWebsiteOngoingActivity),
            this._store.select(fromStore.getAddWebsiteOngoingActivity)
          ))
        )
        .subscribe(([migrationActivity, createActiivity, addWebsiteActivity]) => {
          if (!migrationActivity && !createActiivity && !addWebsiteActivity) {
            this.disableCopyWebsite = false;
            return;
          }

          const ongoingActivity = migrationActivity ? migrationActivity : (createActiivity ? createActiivity : addWebsiteActivity);
          switch (ongoingActivity.status) {
            case ActivityStatus.DONE:
            case ActivityStatus.FAILED:
              this.disableCopyWebsite = false;
              break;

            default:
              this.disableCopyWebsite = true;
              break;
          }
        })
    );

    this._subscriptions.push(
      combineLatest(
        this._store.select(fromStore.getUserLoaded),
        this._store.select(fromStore.getWebsitesLoaded)
      )
        .pipe(
          filter(([userLoaded, websitesLoaded]) => userLoaded && websitesLoaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getUser),
            this._store.select(fromStore.getUserSubscription),
            this._store.select(fromStore.getCurrentWorkspace),
            this._store.select(fromStore.getWorkspaces),
            this._store.select(fromStore.getOwnerWorkspace),
            this._store.select(fromStore.getUserLocalStorage),
            this._store.select(fromStore.getWebsites),
            this._store.select(fromStore.getPayments),
            this._store.select(fromStore.getUserUpgradableSubscription()),
            this._store.select(fromStore.getUserAvailableHostingSubscriptions())
          ))
        )
        .subscribe(([user, userSubscription, currentWorkspace, workspaces, ownerWorkspace, userLocalStorage, websites,
                      payments, upgradableSubscriptions, availableHostingSubscriptions]) => {
          this.user = user;
          this.demoUser = Utils.isDemoUser(userSubscription, user);
          this.fromGallery = this.user && Config.photoGalleryPluginIds.includes(this.user?.connectedFromProductId.toString());
          this.userSubscription = userSubscription;
          if (userSubscription?.editTotal) {
            this.vibeLimitationData = {
              planLimit: userSubscription.editTotal,
              alreadyUsed: userSubscription.editUsed ?? 0,
            };
          }
          this.userLocalStorage = userLocalStorage || {};
          this.user && this._checkFreeTrialTooltipOpened();
          this.hasApiService = userSubscription?.plan?.apiResellerService && (!userSubscription.plan.apiResellerService['disable_api_key'] || (userSubscription?.plan?.apiResellerService['disable_api_key'] && userSubscription?.plan?.apiResellerService['disable_api_key'].parameter_value !== '1'));
          this.trialOrOptimizerTrial = this.userSubscription?.trialClient || this.userSubscription?.trialOptimizerClient;
          this.currentWorkspace = currentWorkspace;
          this.isSiteDev = this.currentWorkspace && this.currentWorkspace.roleId === clientRoles.SITE_DEV;
          this.isTrialExpired = this.userSubscription && this.userSubscription.type === UserSubscriptionType.FREE && this.user?.hostingTrialExpired;
          this.expiredSubscr = this.userSubscription && ([this.userSubscriptionStatus.failed, this.userSubscriptionStatus.expired].includes(this.userSubscription.status)
            || this.userSubscription.isExpired);
          this.ownerWorkspace = ownerWorkspace;
          this.nps = userLocalStorage && userLocalStorage.nps;
          this.referralPageSeen = userLocalStorage && userLocalStorage.referralPageSeen;
          this.websites = websites;
          this.payments = payments;
          this.hostedWebsites = this.websites?.filter((website: Website) => !website.parentId && !website.isNetwork && website.isActive && website.type === 'live' && !!website.domain_hash);
          this.hostedWebsitesWithMulti = this.websites?.filter((website: Website) => !website.parentId && website.isActive && website.type === 'live' && !!website.domain_hash);
          this.connectedWebsites = this.websites?.filter((website: Website) => !website.parentId && !website.isNetwork && website.isActive && website.type === 'live' && !website.domain_hash);
          const hostingsLimit = this.user && this.user.hosting_services && this.userSubscription && this.userSubscription.plan ? parseInt(this.user.hosting_services.domain_count.parameter_value, 10) + this.user.additionalWebsiteCount : null;
          const oneMonthFreeWithAvailableDomains = this.userSubscription && this.userSubscription.freeDaysBeforePayment && !this.disableCopyWebsite
            && this.hostedWebsitesWithMulti.length < hostingsLimit
            && +Utils.getDaysDiffFromToday(this.userSubscription.agreementDate, false) > 1
            && this.currentWorkspace?.roleId !== clientRoles.SITE_DEV;
          this.bluredContent = oneMonthFreeWithAvailableDomains
            && (TypeUtils.isNull(localStorage.getItem('websiteAvailableGotIt' + this.user.id)) || +Utils.getDaysDiffFromToday(localStorage.getItem('websiteAvailableGotIt' + this.user.id), false) >= 7);
          userLocalStorage && !TypeUtils.isEmpty(userLocalStorage) && this.innerVariables();
          if (userSubscription?.plan?.vibeService) {
            this._store.dispatch(new fromStore.LoadVibeLimitations());
          }
          this.workspaces = [];
          workspaces && workspaces.length && workspaces.forEach(workspace => {
            if (workspace && !['invited'].includes(workspace.status)) {
              workspace.roleId === clientRoles.OWNER ? this.workspaces.unshift(workspace) : this.workspaces.push(workspace);
            }
          });
          this.hasUpgrade = !!upgradableSubscriptions && !((availableHostingSubscriptions.length === 1 &&
            !this.userSubscription?.isApiResellerPlan) && availableHostingSubscriptions.filter((_userSubscription => _userSubscription?.tabCategory === this.userSubscription?.tabCategory)));
          this.showButtonsOrNot();
          this.showOrNot();
        })
    );

    this._subscriptions.push(this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(() => {
        this.routeData = this._routeDataService.getCurrentRouteData();
        this.hideMenuItems = this.userSubscription &&
          ((this.userSubscription.trialOptimizerClient && (!this.websites || (this.websites && !this.websites.length))) ||
            ((this.user && this.userSubscription.oneProductClient && !this.user.websiteCreated && !this.user.websiteConnected)
              && (!this.websites || (this.websites && !this.websites.length))));
      })
    );
  }

  private removeSubscriptions(): void {
    if (this._subscriptions) {
      this._subscriptions.forEach((subscription: Subscription): void => {
        subscription.unsubscribe();
      });
    }
    this._subscriptions = null;
  }

  public showOrNot(): void {
    this.conditionalPages = ['migration-steps', 'add-website', 'setup', 'setup-onboarding', 'move-hosting', 'change-hosting', 'optimize', 'buy-speed-optimizer', 'create', 'options', 'other'].includes(this.routeData.pageId);
    this.checkPageAndWorkspace = !this.isWorkspaceStatusInvited && !this.conditionalPages;
    this.showActivitiesIcon = !this.trialOrOptimizerTrial
      || ((this.trialOrOptimizerTrial && this.user && !this.user.hostingTrialExpired) && this.routeData.pageId !== 'add-website');
  }


  public switchToUserManagement(page): void {
    // this.sidebarNavigationService.switchToUserManagement(this.userLocalStorage, (loading) => this.switchLoading.emit(loading));
    this._changePage(page);
  }

  public switchToDomains(page): void {
    // this.sidebarNavigationService.switchToDomains(this.userLocalStorage, this.userSubscription, this.currentWorkspace, (loading) => this.switchLoading.emit(loading));
    this._changePage(page);
  }

  public switchToPaymentsPage(page): void {
    // this.sidebarNavigationService.switchToPayments(this.userLocalStorage, (loading) => this.switchLoading.emit(loading));
    this._changePage(page);
  }

  private _changePage(page): void {
    this.page = page;
  }

  public showUpgradeDialog(label: string): void {
    this.sidebarNavigationService.showUpgradeDialog(label, this.demoUser);
  }

  public toggleSidebar(): void {
    // Toggle the collapsed state
    this.isSidebarCollapsedSignal.update(value => !value);

    // Always close workspace popup when toggling sidebar
    this.sidebarNavigationService.isWorkspacePopupOpen.next(false);

    // In mobile view, also update the service's visibility state
    if (this.isMobile) {
      this.sidebarNavigationService.toggleSidebar(!this.isSidebarCollapsed);
    }
  }

  public toggleAnimation() {
    this.iconAnimation = true;
    setTimeout(() => {
      this.iconAnimation = false;
    }, 400);
  }

  public getWhatsAppUrl(): string {
    if (!this.companyInfo?.branding?.whatsapp_number) {
      return '';
    }
    const phoneNumber = this.companyInfo.branding.whatsapp_number;
    const message = this.companyInfo.branding.whatsapp_message;

    if (message) {
      return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    }
    return `https://wa.me/${phoneNumber}`;
  }

}
